module.exports = __webpack_public_path__ + "components/switch-units/static/preferences-white-fe043e5f9f6b13d2831d771e9c5994c7.svg";